// packages/react/src/bootstrap.tsx
//
// Browser bootstrap entry for the IVW-2.0 React app-shell/router.
//
// Mirrors the WORKING v1 bootstrap (InductVisibilityWebsite-1.0/src/index.js):
//   1. Ask the SCC parent shell for the user's locale via getLocale() (LocaleHandler).
//   2. Set <html dir="rtl"> for Arabic, else "ltr".
//   3. Mount React under <IntlProvider locale messages> so the migrated screens'
//      react-intl (`FormattedMessage`/`injectIntl`) usage has the right catalog.
//   4. App itself supplies HashRouter + Theme + DeviceLayoutProvider.
//
// React 16.14 (see packages/react/package.json) -> `ReactDOM.render` is the
// correct mount API (createRoot is React 18+). @amzn/meridian is pinned at ^5
// (aligned with v1) which supports React 16 natively.

import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import App from './components/App';
import { getDirection, getLocale, getMessages } from './components/i18n/LocaleHandler';

function mount(locale: string): void {
  document.documentElement.setAttribute('dir', getDirection(locale));
  ReactDOM.render(
    <IntlProvider locale={locale} messages={getMessages(locale)}>
      <App />
    </IntlProvider>,
    document.getElementById('root'),
  );
}

getLocale()
  .then((locale) => mount(locale))
  .catch(() => mount('en'));
